import React from 'react';
function AlignCenterHorizontal({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <path
        d="M10.6 3.33334V16.6667M7.93335 8.66667H5.26668C4.91306 8.66667 4.57392 8.52619 4.32387 8.27614C4.07383 8.0261 3.93335 7.68696 3.93335 7.33334V6C3.93335 5.26667 4.53335 4.66667 5.26668 4.66667H7.93335M13.2667 8.66667H15.9333C16.287 8.66667 16.6261 8.52619 16.8762 8.27614C17.1262 8.0261 17.2667 7.68696 17.2667 7.33334V6C17.2667 5.64638 17.1262 5.30724 16.8762 5.05719C16.6261 4.80714 16.287 4.66667 15.9333 4.66667H13.2667M7.93335 15.3333H7.26668C6.91306 15.3333 6.57392 15.1929 6.32387 14.9428C6.07383 14.6928 5.93335 14.3536 5.93335 14V12.6667C5.93335 11.9333 6.53335 11.3333 7.26668 11.3333H7.93335M13.2667 11.3333H13.9333C14.287 11.3333 14.6261 11.4738 14.8762 11.7239C15.1262 11.9739 15.2667 12.313 15.2667 12.6667V14C15.2667 14.3536 15.1262 14.6928 14.8762 14.9428C14.6261 15.1929 14.287 15.3333 13.9333 15.3333H13.2667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default AlignCenterHorizontal;
